module.exports = __webpack_public_path__ + "static/media/Silver.b2f1f659.png";